import { IChuongTrinhDaoTaoActionTypes } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoActions";
import { IChuongTrinhDaoTaoReducer } from "../../reducer-model/chuong-trinh-dao-tao/IChuongTrinhDaoTaoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IChuongTrinhDaoTaoReducer = {
    status: eReducerStatusBase.is_not_initialization,
    chuongTrinhDaoTaos: [],
};
export const chuongTrinhDaoTaoReducer = (
    state: IChuongTrinhDaoTaoReducer = iniState,
    action: IChuongTrinhDaoTaoActionTypes
): IChuongTrinhDaoTaoReducer => {
    switch (action.type) {
        case "CHUONG_TRINH_DAO_TAO_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUONG_TRINH_DAO_TAO_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chuongTrinhDaoTaos: action.payload,
            };
        case "CHUONG_TRINH_DAO_TAO_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUONG_TRINH_DAO_TAO_CHANGE_CTDT_SELECTED":
            return {
                ...state,
                chuongTrinhDaoTaoSelected: action.payload
            };          
        case "CHUONG_TRINH_DAO_TAO_UPLOAD_CONG_THUC_MODAL_OPEN":
            return {
                ...state,
                isShowUploadCongThucModal: true
            };
        case "CHUONG_TRINH_DAO_TAO_UPLOAD_CONG_THUC_MODAL_CLOSE":
            return {
                ...state,
                isShowUploadCongThucModal: false
            };
        default:
            return state;
    }
};
